import { customElement, property } from 'lit/decorators.js';
import { html, LitElement, TemplateResult } from 'lit';
import { AdoptedStyleSheets } from '../../controllers/adopted-stylesheets';
import innerCSS from './se-grid-r.inner.pcss?inline';
import { styleMap } from 'lit/directives/style-map.js';

@customElement('se-grid-r')
export class SEGridR extends LitElement {
  private stylesheetController = new AdoptedStyleSheets(this, {
    encapsulatedCSS: innerCSS,
  });

  /** Number of columns in the grid, accepts integers. */
  @property({
    type: String,
    attribute: 'se-grid-cols',
  })
  columns = '3';

  /** Gap between grid columns, accepts CSS length values. */
  @property({
    type: String,
    attribute: 'se-grid-col-gap',
  })
  columnGap = '1rem';

  /** Gap between grid rows, accepts CSS length values. */
  @property({
    type: String,
    attribute: 'se-grid-row-gap',
  })
  rowGap = '1rem';

  /** Minimum width for grid items, accepts CSS length values. Only used with `fluid` grid type. */
  @property({
    type: String,
    attribute: 'se-grid-min-item-width',
  })
  minItemWidth = '1fr';

  /**
   * Grid layout type. `default` uses a set number of columns. `fluid` uses as many columns as grid items can
   * fit at the minimum item width. Both `default` and `fluid` reduce to a single column below 1024px.
   */
  @property({
    type: String,
    attribute: 'se-grid-type',
  })
  gridType: 'default' | 'fluid' = 'default';

  render(): TemplateResult {
    const userStyles = {
      '--grid-cols': this.columns,
      '--grid-col-gap': this.columnGap,
      '--grid-row-gap': this.rowGap,
      '--grid-item-min-width': this.minItemWidth
    };
    return html`
      <div class="se-grid ${this.gridType === 'fluid' ? 'fluid' : ''}" style="${styleMap(userStyles)}">
        <slot></slot>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'se-grid-r': SEGridR;
  }
}
